import React, { useState } from 'react';
import { Container, Row, Col, Image, Modal, Button } from 'react-bootstrap';
import whatToBringImage from '../assets/images/whatToBring.jpg';

const WhatToBring = () => {
  const [showModal, setShowModal] = useState(false);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = whatToBringImage;
    link.download = 'what-to-bring-bootcamp.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="what-to-bring py-5 bg-light" id="what-to-bring">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} className="text-center">
            <h2 className="fw-bold mb-4">WHAT TO BRING</h2>
            <p className="lead mb-4">Make sure you're prepared for an amazing bootcamp experience!</p>
            
            <div className="poster-container mb-4">
              <Image 
                src={whatToBringImage} 
                alt="What to Bring to Bootcamp" 
                className="img-fluid shadow rounded"
                style={{ cursor: 'pointer', maxHeight: '70vh' }}
                onClick={() => setShowModal(true)}
              />
            </div>
            
            <div className="poster-actions">
              <Button 
                variant="primary" 
                className="me-2"
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-zoom-in me-1"></i> View Full Size
              </Button>
              <Button 
                variant="outline-primary"
                onClick={handleDownload}
              >
                <i className="bi bi-download me-1"></i> Download List
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Modal for expanded view */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        size="lg" 
        centered
        fullscreen="md-down"
      >
        <Modal.Header closeButton>
          <Modal.Title>What to Bring - Bootcamp Checklist</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-0">
          <Image 
            src={whatToBringImage} 
            alt="What to Bring to Bootcamp" 
            className="img-fluid"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleDownload}>
            <i className="bi bi-download me-1"></i> Download
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default WhatToBring;